import React from "react";
import { Box, Typography } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { styles } from "./styleSavedPostHeader";

const SavedPostHeader: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const type = searchParams.get("type") || "Post";

  const activeTab = type === "Post" ? "Saved Post" : "Purchased posts";

  const handleTabClick = (tab: "Saved Post" | "Purchased posts") => {
    const newType = tab === "Saved Post" ? "Post" : "Articles";
    navigate(`/saved-post?type=${newType}`);
  };

  return (
    <Box sx={styles.header}>
      <Typography
        variant="h3"
        sx={{
          fontFamily: "Inter",
          fontWeight: 600,
          fontSize: "15px",
          lineHeight: "24px",
          letterSpacing: 0,
          color: "#383C40",
        }}
      >
        Saved Post
      </Typography>

      <Box sx={styles.tabsBox}>
        <Typography
          onClick={() => handleTabClick("Saved Post")}
          sx={styles.tabItem(activeTab === "Saved Post")}
        >
          Saved Post
        </Typography>
        <Typography
          onClick={() => handleTabClick("Purchased posts")}
          sx={styles.tabItem(activeTab === "Purchased posts")}
        >
          Purchased posts
        </Typography>
      </Box>
    </Box>
  );
};

export default SavedPostHeader;
